import React from 'react';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';
import { OrderLine } from './OrderLine';
import { isOrderOpen } from '../../../../../../../stores/websocketStore/utils/mungingUtils/orderStatusFilter';
export interface Order {
  status: string;
  brokerage: string;
  symbol: string;
  id: string | number;
}
interface Props {
  symbol: string;
  tradePlanId: string | number;
  size: number;
  scaleY: (value: number) => number;
  portalRef: {
    current: any;
  };

}
export const OrdersContainer: React.FC<Props> = observer(
  ({ symbol, tradePlanId, size, scaleY, portalRef }: Props) => {
    const { tradePlanStore } = useWebsocketStore();
    const orders: Order[] = tradePlanStore.ordersByTradePlanId[tradePlanId] ?? null;
    if (!orders) return null;
    const ordersArray = Object.values(
      tradePlanStore.ordersByTradePlanId[tradePlanId]
    ).filter((order: Order) => {
      return (
        isOrderOpen(order.status, order.brokerage) && order.symbol === symbol
      );
    });
    return (
      <g>
        {ordersArray.map((order: Order) => (
          <OrderLine
            key={order.id}
            order={order}
            size={size}
            scaleY={scaleY}
            portalRef={portalRef}
          />
        ))}
      </g>
    );
  }
);
